import { useStore } from '@mirai/data-sources';
import { useLocale } from '@mirai/locale';
import { useMemo } from 'react';

import { DATASOURCE } from '../../../__shared__/Occupation/Occupation.constants';
import { getDetailsByRoom, getRoomDataSource } from '../../helpers';

const EMPTY_ARRAY = [];

const useSelectedRoomData = ({ details = EMPTY_ARRAY, room, rooms = EMPTY_ARRAY } = {}) => {
  const { translate } = useLocale();
  const { value: storeValue = {} } = useStore() || {};

  const hotelId = storeValue?.hotel?.id;
  const occupationVariants = Array.isArray(storeValue?.occupation?.variants)
    ? storeValue.occupation.variants
    : EMPTY_ARRAY;
  const variantDataSource = occupationVariants.find(({ id } = {}) => id.toString() === hotelId?.toString())?.occupation;
  const configDataSource = Array.isArray(variantDataSource)
    ? variantDataSource
    : Array.isArray(storeValue?.occupation?.dataSource)
    ? storeValue.occupation.dataSource
    : DATASOURCE;

  const roomId = room?.id;

  const selectedRoom = useMemo(() => {
    if (roomId === undefined || roomId === null) return undefined;

    return rooms.find(({ id } = {}) => id === roomId);
  }, [roomId, rooms]);

  const roomDataSource = useMemo(
    () =>
      getRoomDataSource({
        configDataSource,
        details,
        occupation: selectedRoom ? [selectedRoom] : EMPTY_ARRAY,
        translate,
      }),
    [configDataSource, details, selectedRoom, translate],
  );

  const totalRooms = useMemo(() => getDetailsByRoom(details).length, [details]);

  const selectedRoomData = useMemo(
    () =>
      roomDataSource.find(
        ({ room: roomValue } = {}) =>
          roomValue?.id === room?.id &&
          (room?.index === undefined || room?.index === null || roomValue?.index === room?.index),
      ),
    [room, roomDataSource],
  );

  const showSelectedRoom = totalRooms > 1 && selectedRoomData !== undefined;

  return { configDataSource, roomDataSource, selectedRoom, selectedRoomData, showSelectedRoom };
};

export { useSelectedRoomData };
